import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    selectItem: {
      boxSizing: "border-box",
      border: "0 none",
      padding: "16px",
      cursor: "pointer",
      borderRadius: "4px",
      backgroundColor: "inherit",
      fontFamily: "inherit",
      fontWeight: "inherit",
      color: "inherit",
      textAlign: "left",
    },
    hoverBorder: {
      "&:hover": {
        borderWidth: "1px",
        borderStyle: "solid",
      },
    },
    noBorder: {
      borderTopColor: "none",
      borderLeftColor: "none",
      borderRightColor: "none",
      borderBottomColor: "none",
      borderTopWidth: "0",
      borderLeftWidth: "0",
      borderRightWidth: "0",
      borderBottomWidth: "0",
      borderStyle: "none",
    },
  },
  { name: "N0SelectItem" },
);

export { useStyles };
